/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ApprovalRequirementEnum {
  FINAL_PROJECT = "FINAL_PROJECT",
  NOT_REQUIREMENT = "NOT_REQUIREMENT",
  QUIZ_EVALUATION = "QUIZ_EVALUATION",
}

export enum BannerIdentifier {
  ALL_MEMBERSHIPS = "ALL_MEMBERSHIPS",
  CATALOG_CAMPAIGN = "CATALOG_CAMPAIGN",
  EXPIRE_MEMBERSHIP = "EXPIRE_MEMBERSHIP",
  MEMBERSHIP_CAMPAIGN = "MEMBERSHIP_CAMPAIGN",
  MEMBERSHIP_LANDING = "MEMBERSHIP_LANDING",
  NEW_USER = "NEW_USER",
  REFER_FRIEND = "REFER_FRIEND",
  REMINDER_SUBSCRIPTION = "REMINDER_SUBSCRIPTION",
  RENOVATE_MEMBERSHIP = "RENOVATE_MEMBERSHIP",
  SHOPPING_CART = "SHOPPING_CART",
}

export enum BannerLandingEnum {
  CAMPAIGN_LANDING = "CAMPAIGN_LANDING",
  DEGREE_LANDING = "DEGREE_LANDING",
  MEMBERSHIP_LANDING = "MEMBERSHIP_LANDING",
}

export enum BlockTypeEnum {
  BLOCK_FILE = "BLOCK_FILE",
  BLOCK_HEADING = "BLOCK_HEADING",
  BLOCK_IMAGE = "BLOCK_IMAGE",
  BLOCK_PARAGRAPH = "BLOCK_PARAGRAPH",
  BLOCK_REPOSITORY_LINK = "BLOCK_REPOSITORY_LINK",
  BLOCK_SUBHEADING = "BLOCK_SUBHEADING",
  BLOCK_VIDEO = "BLOCK_VIDEO",
}

export enum CanEnrollEnum {
  ENROLL_B2B = "ENROLL_B2B",
  ENROLL_DEGREE = "ENROLL_DEGREE",
  ENROLL_FREE = "ENROLL_FREE",
  ENROLL_FREEMIUM = "ENROLL_FREEMIUM",
  ENROLL_FREE_MEMBERSHIP = "ENROLL_FREE_MEMBERSHIP",
  ENROLL_MEMBERSHIP = "ENROLL_MEMBERSHIP",
  ENROLL_MENTOR = "ENROLL_MENTOR",
  ENROLL_PREVIEW_TRIAL = "ENROLL_PREVIEW_TRIAL",
  ENROLL_PROFESSOR = "ENROLL_PROFESSOR",
  ENROLL_STAFF = "ENROLL_STAFF",
  ENROLL_TEMPORAL_ACCESS = "ENROLL_TEMPORAL_ACCESS",
  ENROLL_USER_REGISTER_TEMPORAL_ACCESS = "ENROLL_USER_REGISTER_TEMPORAL_ACCESS",
}

export enum CapstoneProjectOrderByEnum {
  ORDER_BY_DATE = "ORDER_BY_DATE",
  ORDER_BY_USER = "ORDER_BY_USER",
}

export enum CapstoneProjectStateEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  FINISHED = "FINISHED",
  OBSERVED = "OBSERVED",
  PUBLISHED = "PUBLISHED",
}

export enum CertificateTypeEnum {
  ACADEMY_SKILL_PATH = "ACADEMY_SKILL_PATH",
  B2B_TRACK = "B2B_TRACK",
  CAREER = "CAREER",
  CERTIFICATION = "CERTIFICATION",
  COURSE = "COURSE",
}

export enum ClaimTypeEnum {
  QUEJA = "QUEJA",
  RECLAMO = "RECLAMO",
}

export enum ContactSourceEnum {
  SOURCE_B2B_LANDING_MENU_MOBILE = "SOURCE_B2B_LANDING_MENU_MOBILE",
  SOURCE_B2B_LAST_SECTION = "SOURCE_B2B_LAST_SECTION",
  SOURCE_BLOG_ARTICLE_DETAIL = "SOURCE_BLOG_ARTICLE_DETAIL",
  SOURCE_BLOG_BANNER = "SOURCE_BLOG_BANNER",
  SOURCE_BLOG_CATEGORIES = "SOURCE_BLOG_CATEGORIES",
  SOURCE_BLOG_DETAIL = "SOURCE_BLOG_DETAIL",
  SOURCE_BLOG_HOME = "SOURCE_BLOG_HOME",
  SOURCE_CALL_CENTER_CATALOG_POPUP = "SOURCE_CALL_CENTER_CATALOG_POPUP",
  SOURCE_CALL_CENTER_DIALOG_BLOG = "SOURCE_CALL_CENTER_DIALOG_BLOG",
  SOURCE_CALL_CENTER_DIALOG_BLOG_DETAIL = "SOURCE_CALL_CENTER_DIALOG_BLOG_DETAIL",
  SOURCE_CALL_CENTER_DIALOG_HOME = "SOURCE_CALL_CENTER_DIALOG_HOME",
  SOURCE_CALL_CENTER_HOME_CTA_BUTTON = "SOURCE_CALL_CENTER_HOME_CTA_BUTTON",
  SOURCE_CAMPAIGN_LANDING_MENU = "SOURCE_CAMPAIGN_LANDING_MENU",
  SOURCE_CHECKOUT = "SOURCE_CHECKOUT",
  SOURCE_CLASSROOM = "SOURCE_CLASSROOM",
  SOURCE_COUPON_PREMIUM = "SOURCE_COUPON_PREMIUM",
  SOURCE_COURSE_DETAIL_MEMBERSHIP_POPUP = "SOURCE_COURSE_DETAIL_MEMBERSHIP_POPUP",
  SOURCE_COURSE_FREE_LANDING = "SOURCE_COURSE_FREE_LANDING",
  SOURCE_COURSE_FREE_OF_THE_DAY = "SOURCE_COURSE_FREE_OF_THE_DAY",
  SOURCE_COURSE_OPTION = "SOURCE_COURSE_OPTION",
  SOURCE_DEGREE = "SOURCE_DEGREE",
  SOURCE_DOWNLOAD_FREE_RESOURCE = "SOURCE_DOWNLOAD_FREE_RESOURCE",
  SOURCE_HOME_HERO = "SOURCE_HOME_HERO",
  SOURCE_HOME_PHONE_NUMBER = "SOURCE_HOME_PHONE_NUMBER",
  SOURCE_HOME_POP_UP = "SOURCE_HOME_POP_UP",
  SOURCE_HOME_TOP_BANNER = "SOURCE_HOME_TOP_BANNER",
  SOURCE_HOME_USER_PAYG = "SOURCE_HOME_USER_PAYG",
  SOURCE_LANDING_LIVE = "SOURCE_LANDING_LIVE",
  SOURCE_LANDING_TOOLS = "SOURCE_LANDING_TOOLS",
  SOURCE_MEMBERSHIP_CATEGORY_LANDING = "SOURCE_MEMBERSHIP_CATEGORY_LANDING",
  SOURCE_MEMBERSHIP_LANDING = "SOURCE_MEMBERSHIP_LANDING",
  SOURCE_MEMBERSHIP_LANDING_COMPONENT = "SOURCE_MEMBERSHIP_LANDING_COMPONENT",
  SOURCE_MEMBERSHIP_LANDING_MENU = "SOURCE_MEMBERSHIP_LANDING_MENU",
  SOURCE_ORGANIC = "SOURCE_ORGANIC",
  SOURCE_PRE_CHECKOUT = "SOURCE_PRE_CHECKOUT",
  SOURCE_PRE_REGISTRATION_ALL_ACCESS = "SOURCE_PRE_REGISTRATION_ALL_ACCESS",
  SOURCE_PROJECT_CREATION = "SOURCE_PROJECT_CREATION",
  SOURCE_REGISTER_FUNNEL = "SOURCE_REGISTER_FUNNEL",
  SOURCE_REMARKETING_HERO = "SOURCE_REMARKETING_HERO",
  SOURCE_ROULETTE_HOME = "SOURCE_ROULETTE_HOME",
  SOURCE_SEARCH_POP_UP = "SOURCE_SEARCH_POP_UP",
  SOURCE_SOFE = "SOURCE_SOFE",
  SOURCE_STUDENT_MEMBERSHIP_LANDING = "SOURCE_STUDENT_MEMBERSHIP_LANDING",
  SOURCE_STUDENT_PLAN = "SOURCE_STUDENT_PLAN",
  SOURCE_TEMPLATE_PAAS_MENU = "SOURCE_TEMPLATE_PAAS_MENU",
  SOURCE_TEMPORAL_ACCESS_LANDING = "SOURCE_TEMPORAL_ACCESS_LANDING",
  SOURCE_TEMPORAL_OR_FREE = "SOURCE_TEMPORAL_OR_FREE",
  SOURCE_TRACK_LANDING = "SOURCE_TRACK_LANDING",
}

export enum CourseTypeEnum {
  COURSE_TYPE_B2B = "COURSE_TYPE_B2B",
  COURSE_TYPE_B2B_CLASSROOMS = "COURSE_TYPE_B2B_CLASSROOMS",
  COURSE_TYPE_DEGREE = "COURSE_TYPE_DEGREE",
  COURSE_TYPE_FREE = "COURSE_TYPE_FREE",
  COURSE_TYPE_MEMBERSHIP = "COURSE_TYPE_MEMBERSHIP",
  COURSE_TYPE_PAID = "COURSE_TYPE_PAID",
  COURSE_TYPE_ROCKSTAR = "COURSE_TYPE_ROCKSTAR",
  COURSE_TYPE_TEMPORAL_ACCESS = "COURSE_TYPE_TEMPORAL_ACCESS",
}

export enum CourseVideoTrailerSourceVideoSourceType {
  HLSV3 = "HLSV3",
  HLSV4 = "HLSV4",
  MP3 = "MP3",
  MP4 = "MP4",
  NONE = "NONE",
}

export enum DegreeLearningCourseDetailProjectTypeEnum {
  PROJECT_TYPE_OPTIONAL = "PROJECT_TYPE_OPTIONAL",
  PROJECT_TYPE_REQUIRED = "PROJECT_TYPE_REQUIRED",
}

export enum DegreeLearningEventScheduleTargetEnum {
  TARGET_COMPLEMENTARY_SESSION = "TARGET_COMPLEMENTARY_SESSION",
  TARGET_COUNSELLING = "TARGET_COUNSELLING",
  TARGET_KICKOFF = "TARGET_KICKOFF",
}

export enum DegreeSyllabusStatusEnum {
  STATUS_CLOSURE = "STATUS_CLOSURE",
  STATUS_FINISHED = "STATUS_FINISHED",
  STATUS_ONBOARDING = "STATUS_ONBOARDING",
  STATUS_PROGRESS = "STATUS_PROGRESS",
  STATUS_SALE = "STATUS_SALE",
}

export enum DocumentTypeClaimEnum {
  CE = "CE",
  DNI = "DNI",
  PASAPORTE = "PASAPORTE",
}

export enum EmploymentSituationTypeEnum {
  FREELANCE_EMPLOYEE = "FREELANCE_EMPLOYEE",
  FULL_TIME_EMPLOYEE = "FULL_TIME_EMPLOYEE",
  PART_TIME_EMPLOYEE = "PART_TIME_EMPLOYEE",
  UNEMPLOYED = "UNEMPLOYED",
}

export enum EnrollmentTypeEnum {
  ENROLLMENT_B2B = "ENROLLMENT_B2B",
  ENROLLMENT_DEGREE = "ENROLLMENT_DEGREE",
  ENROLLMENT_FREE = "ENROLLMENT_FREE",
  ENROLLMENT_FREEMIUM = "ENROLLMENT_FREEMIUM",
  ENROLLMENT_FREE_MEMBERSHIP = "ENROLLMENT_FREE_MEMBERSHIP",
  ENROLLMENT_GITCARD = "ENROLLMENT_GITCARD",
  ENROLLMENT_MEMBERSHIP = "ENROLLMENT_MEMBERSHIP",
  ENROLLMENT_MENTOR = "ENROLLMENT_MENTOR",
  ENROLLMENT_PAID = "ENROLLMENT_PAID",
  ENROLLMENT_PREVIEW_TRIAL = "ENROLLMENT_PREVIEW_TRIAL",
  ENROLLMENT_PROFESSOR = "ENROLLMENT_PROFESSOR",
  ENROLLMENT_STAFF = "ENROLLMENT_STAFF",
  ENROLLMENT_TEMPORAL_ACCESS = "ENROLLMENT_TEMPORAL_ACCESS",
}

export enum FamilyPlanMemberStatus {
  A_1 = "A_1",
  A_2 = "A_2",
  A_3 = "A_3",
}

export enum FormLandingTarget {
  A_1 = "A_1",
}

export enum GenderTypeEnum {
  GENDER_FEMALE = "GENDER_FEMALE",
  GENDER_MALE = "GENDER_MALE",
  GENDER_NON_BINARY = "GENDER_NON_BINARY",
  GENDER_NOT_TO_SAY = "GENDER_NOT_TO_SAY",
}

export enum InstructionGradeTypeEnum {
  COMPLETE_PROFESSIONAL_TECHNICIAN = "COMPLETE_PROFESSIONAL_TECHNICIAN",
  COMPLETE_UNIVERSITY = "COMPLETE_UNIVERSITY",
  ELEMENTARY_AND_OR_MIDDLE = "ELEMENTARY_AND_OR_MIDDLE",
  INCOMPLETE_PROFESSIONAL_TECHNICIAN = "INCOMPLETE_PROFESSIONAL_TECHNICIAN",
  INCOMPLETE_UNIVERSITY = "INCOMPLETE_UNIVERSITY",
  MASTERS_AND_0R_DOCTORATE = "MASTERS_AND_0R_DOCTORATE",
}

export enum LanguageEnum {
  LANGUAGE_EN = "LANGUAGE_EN",
  LANGUAGE_ES = "LANGUAGE_ES",
  LANGUAGE_PT = "LANGUAGE_PT",
}

export enum LiveTargetEnum {
  TARGET_HIDDEN = "TARGET_HIDDEN",
  TARGET_PREMIUM = "TARGET_PREMIUM",
  TARGET_PRIVATE = "TARGET_PRIVATE",
  TARGET_PUBLIC = "TARGET_PUBLIC",
}

export enum MembershipTypeTag {
  BECADO = "BECADO",
  FAMILIAR = "FAMILIAR",
  ONG_BECADO = "ONG_BECADO",
  ORGANIZATION = "ORGANIZATION",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
  PREMIUM_DUO = "PREMIUM_DUO",
  PREMIUM_LITE = "PREMIUM_LITE",
  PREMIUM_STUDENT = "PREMIUM_STUDENT",
  PROFESIONAL = "PROFESIONAL",
  UNIVERSITY_SCHOLARSHIP = "UNIVERSITY_SCHOLARSHIP",
}

export enum MentorScheduleEnum {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum MentorStatusEnum {
  STATUS_AVAILABLE = "STATUS_AVAILABLE",
  STATUS_TEMPORARY_SUSPENSION = "STATUS_TEMPORARY_SUSPENSION",
  STATUS_UNSUBSCRIBED = "STATUS_UNSUBSCRIBED",
  STATUS_VACATIONS = "STATUS_VACATIONS",
}

export enum MentorTypeEnum {
  MENTOR_CLASS_ROOM = "MENTOR_CLASS_ROOM",
  MENTOR_COMPANIES = "MENTOR_COMPANIES",
  MENTOR_DEGREES = "MENTOR_DEGREES",
  MENTOR_PREMIUM = "MENTOR_PREMIUM",
  MENTOR_STAR = "MENTOR_STAR",
  MENTOR_SUPPORT = "MENTOR_SUPPORT",
}

export enum OnboardingEnum {
  ONBOARDING_FAMILY_PLAN = "ONBOARDING_FAMILY_PLAN",
  ONBOARDING_FREEMIUM = "ONBOARDING_FREEMIUM",
  ONBOARDING_FREE_MS = "ONBOARDING_FREE_MS",
  ONBOARDING_MEMBERSHIP = "ONBOARDING_MEMBERSHIP",
  ONBOARDING_NUMBER_FORM = "ONBOARDING_NUMBER_FORM",
  ONBOARDING_PAYG = "ONBOARDING_PAYG",
  ONBOARDING_SOFE = "ONBOARDING_SOFE",
}

export enum PagePageCouponFlow {
  FLOW_COUPON_DIRECT_APPLY = "FLOW_COUPON_DIRECT_APPLY",
  FLOW_PRODUCT_REGISTER = "FLOW_PRODUCT_REGISTER",
}

export enum PagePartnerType {
  A_0 = "A_0",
  A_1 = "A_1",
  A_2 = "A_2",
}

export enum PageVideoProvider {
  VIMEO = "VIMEO",
  WISTIA = "WISTIA",
}

export enum PersonalGoalTypeEnum {
  APPROVE_MY_FREE_TIME = "APPROVE_MY_FREE_TIME",
  ASCEND_IN_MY_COMPANY = "ASCEND_IN_MY_COMPANY",
  CHANGE_MY_PROFESSIONAL_CARRIER = "CHANGE_MY_PROFESSIONAL_CARRIER",
  GET_A_JOB = "GET_A_JOB",
  IMPROVEMENT_MY_PERSONAL_BRANDING = "IMPROVEMENT_MY_PERSONAL_BRANDING",
  IMPULSE_MY_OWN_BUSINESS = "IMPULSE_MY_OWN_BUSINESS",
  LEARN_NEW_SKILLS = "LEARN_NEW_SKILLS",
  MAKE_MY_TEAM_GROW = "MAKE_MY_TEAM_GROW",
}

export enum ProjectOrderByEnum {
  ORDER_BY_ACTIONS_DATE = "ORDER_BY_ACTIONS_DATE",
  ORDER_BY_DATE = "ORDER_BY_DATE",
  ORDER_BY_SUBCATEGORY = "ORDER_BY_SUBCATEGORY",
  ORDER_BY_USER = "ORDER_BY_USER",
}

export enum ProjectParticipationCertificateEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  PUBLISH = "PUBLISH",
}

export enum ProjectPrivacyB2BEnum {
  PROJECT_PRIVACY_ONLY_ORGANIZATION = "PROJECT_PRIVACY_ONLY_ORGANIZATION",
  PROJECT_PRIVACY_ONLY_USER = "PROJECT_PRIVACY_ONLY_USER",
}

export enum ProjectPrivacyEnum {
  PRIVACY_ALL_USER = "PRIVACY_ALL_USER",
  PRIVACY_COMMUNITY = "PRIVACY_COMMUNITY",
  PRIVACY_ONLY_USER = "PRIVACY_ONLY_USER",
}

export enum ProjectStateEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  FINISHED = "FINISHED",
  OBSERVED = "OBSERVED",
  PUBLISHED = "PUBLISHED",
}

export enum ProjectUploadValidationEnum {
  B2B_CLASSROOM_COURSE = "B2B_CLASSROOM_COURSE",
  B2B_DEMO = "B2B_DEMO",
  B2B_NO_PROJECT = "B2B_NO_PROJECT",
  TEMPORAL_ACCESS = "TEMPORAL_ACCESS",
  UNIVERSITY_SCHOLARSHIP = "UNIVERSITY_SCHOLARSHIP",
}

export enum ProjectValidationGroupEnum {
  DEFAULT_VALIDATION_GROUP = "DEFAULT_VALIDATION_GROUP",
  VALIDATION_GROUP_FOUR = "VALIDATION_GROUP_FOUR",
  VALIDATION_GROUP_ONE = "VALIDATION_GROUP_ONE",
  VALIDATION_GROUP_THREE = "VALIDATION_GROUP_THREE",
  VALIDATION_GROUP_TWO = "VALIDATION_GROUP_TWO",
}

export enum PusherTargetEnum {
  INBOX = "INBOX",
  LIVE = "LIVE",
}

export enum QuizApprovalEnum {
  APPROVAL_100_PERCENT = "APPROVAL_100_PERCENT",
  APPROVAL_50_PERCENT = "APPROVAL_50_PERCENT",
  APPROVAL_60_PERCENT = "APPROVAL_60_PERCENT",
  APPROVAL_70_PERCENT = "APPROVAL_70_PERCENT",
  APPROVAL_80_PERCENT = "APPROVAL_80_PERCENT",
  APPROVAL_90_PERCENT = "APPROVAL_90_PERCENT",
}

export enum QuizQuestionTypeEnum {
  TYPE_DEVELOPMENT = "TYPE_DEVELOPMENT",
  TYPE_MULTIPLE = "TYPE_MULTIPLE",
  TYPE_SIMPLE = "TYPE_SIMPLE",
}

export enum QuizRetryTimeEnum {
  RETRY_TIME_120_MIN = "RETRY_TIME_120_MIN",
  RETRY_TIME_180_MIN = "RETRY_TIME_180_MIN",
  RETRY_TIME_240_MIN = "RETRY_TIME_240_MIN",
  RETRY_TIME_60_MIN = "RETRY_TIME_60_MIN",
  RETRY_WITHOUT_TIME = "RETRY_WITHOUT_TIME",
}

export enum QuizShowAnswerEnum {
  SHOW_ANSWER_END = "SHOW_ANSWER_END",
  SHOW_ANSWER_IMMEDIATELY = "SHOW_ANSWER_IMMEDIATELY",
  SHOW_ANSWER_NOT_SHOW = "SHOW_ANSWER_NOT_SHOW",
}

export enum QuizTimeLimitEnum {
  TIME_120_MIN = "TIME_120_MIN",
  TIME_30_MIN = "TIME_30_MIN",
  TIME_45_MIN = "TIME_45_MIN",
  TIME_60_MIN = "TIME_60_MIN",
  TIME_WITHOUT = "TIME_WITHOUT",
}

export enum QuizTypeEnum {
  TYPE_CUMULATIVE = "TYPE_CUMULATIVE",
  TYPE_FORMATIVE = "TYPE_FORMATIVE",
}

export enum ScormStatusEnum {
  STATUS_COMPLETE = "STATUS_COMPLETE",
  STATUS_ERROR = "STATUS_ERROR",
  STATUS_INVALID = "STATUS_INVALID",
  STATUS_PROGRESSING = "STATUS_PROGRESSING",
  STATUS_SUBMITTED = "STATUS_SUBMITTED",
}

export enum SendDiscussionValidationEnum {
  B2B_DEMO = "B2B_DEMO",
  TEMPORAL_ACCESS = "TEMPORAL_ACCESS",
  UNIVERSITY_SCHOLARSHIP = "UNIVERSITY_SCHOLARSHIP",
}

export enum ServiceCategoryClaimEnum {
  CURSO = "CURSO",
  MEMBRESIA = "MEMBRESIA",
  OTROS = "OTROS",
  PACK = "PACK",
}

export enum ServiceTypeClaimEnum {
  SERVICIO = "SERVICIO",
}

export enum StatusProjectEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  FINISHED = "FINISHED",
  OBSERVED = "OBSERVED",
  PUBLISHED = "PUBLISHED",
}

export enum StudyPlanFrequencyEnum {
  FREQUENCY_ALL = "FREQUENCY_ALL",
  FREQUENCY_FIVE = "FREQUENCY_FIVE",
  FREQUENCY_ONE = "FREQUENCY_ONE",
  FREQUENCY_THREE = "FREQUENCY_THREE",
  FREQUENCY_TWO = "FREQUENCY_TWO",
}

export enum StudyPlanTargetEnum {
  TARGET_CHILL = "TARGET_CHILL",
  TARGET_INTENSIVE = "TARGET_INTENSIVE",
  TARGET_REGULAR = "TARGET_REGULAR",
}

export enum TimeUnitEnum {
  DAY_UNIT = "DAY_UNIT",
  HOUR_UNIT = "HOUR_UNIT",
  MONTH_UNIT = "MONTH_UNIT",
}

export enum UserSettingsPlayerAudioLanguageCode {
  EN = "EN",
  ES = "ES",
  PT = "PT",
}

export enum UserSettingsPlayerSubtitleLanguageCode {
  EN = "EN",
  ES = "ES",
  PT = "PT",
}

export enum UserTagEnum {
  B2B = "B2B",
  COLLEGE_SCHOLARSHIP = "COLLEGE_SCHOLARSHIP",
  MENTOR = "MENTOR",
  MENTOR_STAR = "MENTOR_STAR",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
  PREMIUM_LITE = "PREMIUM_LITE",
  PREMIUM_STUDENT = "PREMIUM_STUDENT",
  PROFESSIONAL = "PROFESSIONAL",
  PROFESSOR = "PROFESSOR",
  SCHOLARSHIP = "SCHOLARSHIP",
  STAFF = "STAFF",
}

export enum UserTourSectionEnum {
  HOME_USER_DESKTOP_APPS_AD_DIALOG = "HOME_USER_DESKTOP_APPS_AD_DIALOG",
  HOME_USER_MOBILE_APPS_AD_DIALOG = "HOME_USER_MOBILE_APPS_AD_DIALOG",
  HOME_USER_SAVED_COURSES = "HOME_USER_SAVED_COURSES",
  MAIN_MENU_NIGHT_SWITCH = "MAIN_MENU_NIGHT_SWITCH",
  SECTION_COURSE_PLAYER = "SECTION_COURSE_PLAYER",
  SECTION_HOME_USER = "SECTION_HOME_USER",
  SECTION_HOME_USER_B2B = "SECTION_HOME_USER_B2B",
  SECTION_NEW_COURSES = "SECTION_NEW_COURSES",
  SECTION_SKILLPATH_CERTIFICATE_DIALOG = "SECTION_SKILLPATH_CERTIFICATE_DIALOG",
  SECTION_USER_DASHBOARD = "SECTION_USER_DASHBOARD",
  SNACKBAR_EDIT_USER_TASTES = "SNACKBAR_EDIT_USER_TASTES",
  STUDIOS_TOUR = "STUDIOS_TOUR",
  USER_DASHBOARD_SAVED_COURSES = "USER_DASHBOARD_SAVED_COURSES",
}

export enum UserTourStatusEnum {
  COMPLETED = "COMPLETED",
  IGNORE = "IGNORE",
  INCOMPLETE = "INCOMPLETE",
}

export enum VideoLectureSourceProvider {
  CREHANA = "CREHANA",
  NONE = "NONE",
  VIMEO = "VIMEO",
  WISTIA = "WISTIA",
}

export enum VideoLectureTypeEnum {
  VIDEO_LECTURE_BREAK = "VIDEO_LECTURE_BREAK",
  VIDEO_LECTURE_CLASS = "VIDEO_LECTURE_CLASS",
  VIDEO_LECTURE_EXERCISE = "VIDEO_LECTURE_EXERCISE",
  VIDEO_LECTURE_IFRAME = "VIDEO_LECTURE_IFRAME",
  VIDEO_LECTURE_PDF = "VIDEO_LECTURE_PDF",
  VIDEO_LECTURE_QUIZ = "VIDEO_LECTURE_QUIZ",
  VIDEO_LECTURE_SCORM = "VIDEO_LECTURE_SCORM",
  VIDEO_LECTURE_SURVEY = "VIDEO_LECTURE_SURVEY",
}

export enum VideoSpeedEnum {
  SPEED_0_25 = "SPEED_0_25",
  SPEED_0_5 = "SPEED_0_5",
  SPEED_0_75 = "SPEED_0_75",
  SPEED_1 = "SPEED_1",
  SPEED_1_25 = "SPEED_1_25",
  SPEED_1_5 = "SPEED_1_5",
  SPEED_1_75 = "SPEED_1_75",
  SPEED_2 = "SPEED_2",
}

export enum VideoStatusEnum {
  STATUS_CANCELED = "STATUS_CANCELED",
  STATUS_COMPLETE = "STATUS_COMPLETE",
  STATUS_ERROR = "STATUS_ERROR",
  STATUS_PROGRESSING = "STATUS_PROGRESSING",
  STATUS_SUBMITTED = "STATUS_SUBMITTED",
}

/**
 * Input to update a answers.
 * 
 * Attributes:
 *     choice_id (int): choice answer.
 *     text (str): text to answer.
 */
export interface AnswerCreateInput {
  choiceId: number;
  text?: string | null;
}

export interface BlockInput {
  id?: string | null;
  type?: BlockTypeEnum | null;
  value?: string | null;
  filename?: string | null;
  contentType?: string | null;
  size?: string | null;
  updatedAt?: string | null;
}

/**
 * Input to update a course module.
 * 
 * Attributes:
 *     id (int): course module identifier.
 *     course_id (int): course identifier.
 *     name (str): course name.
 *     order (int): number to order the course module.
 *     is_active (Boolean): is course module active.
 */
export interface CourseModuleUpdateInput {
  id: number;
  courseId?: number | null;
  name?: string | null;
  order?: number | null;
  isActive?: boolean | null;
}

export interface LockUserInput {
  idHash: string;
  userId?: number | null;
  clientMutationId?: string | null;
}

export interface ProfileSoftware {
  originalId?: string | null;
  level?: number | null;
}

export interface UnreadInboxInput {
  idHash: string;
  clientMutationId?: string | null;
}

/**
 * Input to update a video lecture.
 * 
 * Attributes:
 *     id (int): video lecture identifier.
 *     module_id (int): course module identifier.
 *     title (str): video lecture title.
 *     order (int): number to order video lecture in module.
 *     duration (float): duration.
 *     provider (str): name of the provider.
 *     video_hashed_id (str): video hashed identifier.
 *     is_active (Boolean): is video lecture active.
 */
export interface VideoLectureUpdateInput {
  id: number;
  moduleId?: number | null;
  title?: string | null;
  order?: number | null;
  duration?: number | null;
  provider?: string | null;
  videoHashedId?: string | null;
  isActive?: boolean | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
